import { CandleValidationApi } from '@voladeum/client';
import { VoladeumResponse } from 'client/types';
import { createQuery } from 'utils/queries';

import { Axios } from '../../axios';

import { normalizeCandleValidations } from './normalizers';
import { CandleValidation, CandleValidationQuery, CandleValidationResetPayload } from './types';

export class VoladeumCandleValidations extends Axios {
  async list(query: CandleValidationQuery): Promise<VoladeumResponse<CandleValidation[]>> {
    const res = await this.get<VoladeumResponse<CandleValidationApi[]>>(
      `/v1/candle-validations${createQuery(query)}`
    );
    return {
      success: res.success,
      error: res.error,
      data: normalizeCandleValidations(res.data),
    };
  }

  async reset(
    pair_id: number,
    unix: number,
    payload: CandleValidationResetPayload
  ): Promise<VoladeumResponse<string>> {
    const res = await this.post<VoladeumResponse<string>>(
      `/v1/pairs/${pair_id}/candle-validations/${unix}/reset`,
      payload
    );
    return {
      success: res.success,
      error: res.error,
      data: res.data,
    };
  }
}
